module.exports = __webpack_public_path__ + "static/media/arrow-right.f1bb5b7a.svg";